
import { defineComponent } from 'vue'

/**
 * 500 Error Page
 */
export default defineComponent({
  name: 'FiveHundred'
})
